import styled from '@mui/material/styles/styled'
import { ReactNode } from 'react'

const MultiItemListContainer = styled('ul')(({ theme }) => ({
  margin: 0,
  marginBlock: 0,
  marginInline: 0,
  listStyle: 'none',
  padding: 0,
  [theme.breakpoints.up('sm')]: {
    paddingRight: '-1rem',
  },
}))

interface MultiItemListProps {
  children: ReactNode
}

const MultiItemList = ({
  children,
}: MultiItemListProps): JSX.Element | null => {
  if (Array.isArray(children) && children.length === 0) return null
  if (!children) return null

  return <MultiItemListContainer role='list'>{children}</MultiItemListContainer>
}

export default MultiItemList
